import React from 'react';
import { Search, RotateCcw, ChevronDown } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

export const Select = ({ label, value, onChange, options, testId }) => (
  <label className="relative flex flex-col justify-center h-14 min-w-[150px] rounded-2xl bg-white border border-slate-200 px-4 hover:border-blue-300 focus-within:border-blue-500 focus-within:ring-4 focus-within:ring-blue-100 transition-[border-color,box-shadow]">
    <span className="text-[11px] text-slate-400 leading-none mb-1">{label}</span>
    <select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className="appearance-none bg-transparent outline-none text-sm font-bold text-slate-800 pe-6 cursor-pointer">
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
    <ChevronDown className="absolute end-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
  </label>
);

export const LibraryToolbar = ({ list, categories, placeholder, testPrefix }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const domains = [{ value: 'all', label: L('الكل', 'All') }, ...categories.map(c => ({ value: c.value, label: lang === 'ar' ? c.ar : c.en }))];
  const sorts = [{ value: 'newest', label: L('الأحدث أولاً', 'Newest first') }, { value: 'oldest', label: L('الأقدم أولاً', 'Oldest first') }, { value: 'popular', label: L('الأكثر مشاهدة', 'Most viewed') }];
  return (
    <div data-testid={`${testPrefix}-toolbar`} className="flex flex-col lg:flex-row gap-3 mb-6">
      <div className="relative flex-1">
        <Search className="absolute start-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
        <input data-testid={`${testPrefix}-search-input`} value={list.query} onChange={(e) => list.setQuery(e.target.value)} placeholder={placeholder}
          className="w-full h-14 rounded-2xl bg-white border border-slate-200 ps-12 pe-4 text-sm sm:text-base outline-none placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-[border-color,box-shadow]" />
      </div>
      <div className="grid grid-cols-2 sm:flex gap-3">
        <Select testId={`${testPrefix}-domain-select`} label={L('المجال', 'Field')} value={list.cat} onChange={list.setCat} options={domains} />
        <Select testId={`${testPrefix}-sort-select`} label={L('الترتيب', 'Sort')} value={list.sort} onChange={list.setSort} options={sorts} />
        <button type="button" data-testid={`${testPrefix}-reset-btn`} onClick={list.reset} disabled={!list.dirty}
          className="col-span-2 sm:col-span-1 h-14 px-5 rounded-2xl border-2 border-blue-200 text-blue-700 font-bold text-sm inline-flex items-center justify-center gap-2 hover:bg-blue-50 disabled:opacity-50 disabled:hover:bg-transparent transition-colors">
          <RotateCcw className="w-4 h-4" />{L('إعادة تعيين الفلاتر', 'Reset filters')}
        </button>
      </div>
    </div>
  );
};
